import { NormalizedTicketTypeVariety } from '../../types/ticketPriceInformation';
import { consumer, core } from '@tock/coretypes';

export type OfferingPartyItem = 'ticket' | 'guest' | 'package' | 'order' | 'party';
export const varietyToOfferingPartyItemMap: {
  [K in NormalizedTicketTypeVariety | consumer.Offering.Type]: OfferingPartyItem;
} = {
  DEPOSIT: 'guest',
  FULL: 'guest',
  PRIX_FIXE: 'guest',
  RESERVATION: 'guest',
  DEPRECATED_EVENT: 'ticket',
  GA_EVENT: 'ticket',
  SEATED_EVENT: 'ticket',
  DEPRECATED_SPECIAL_TABLE: 'guest',
  ORDER_DELIVERY: 'guest',
  ORDER_PICKUP: 'guest', // TODO(jacob): Revisit this
  TABLESIDE: 'guest',
  PAYMENT_CARD_HOLD: 'guest',
};

export const descriptiveVarietyToOfferingPartyItemMap: Record<
  core.DescriptiveVariety,
  OfferingPartyItem | undefined
> = {
  TOGO_A_LA_CARTE: 'order',
  TOGO_PACKAGE: 'package',
  TOGO_PRIX_FIXE: undefined,
};

export const ticketPriceDistributionToOfferingPartyItemMap: {
  [K in core.TicketPriceInformation.PriceDistribution]: OfferingPartyItem | undefined;
} = {
  PER_PARTY: 'party',
  PER_TICKET: undefined, // fall back to variety-based map
};

/**
 * Returns the name of what an individual purchase item is for an offering,
 * such as a ticket or a guest. Used for party size selector where a user selects
 * how many guests or tickets they would like to purchase
 * e.g. RESERVATION -> ticket, SPECIAL_TABLE -> guest, DEPOSIT -> guest
 */
export function offeringPartyItem(
  variety: NormalizedTicketTypeVariety | consumer.Offering.Type,
  descriptiveVariety?: core.DescriptiveVariety,
  priceDistribution?: core.TicketPriceInformation.PriceDistribution
): OfferingPartyItem {
  return (
    (descriptiveVariety && descriptiveVarietyToOfferingPartyItemMap[descriptiveVariety]) ??
    (priceDistribution && ticketPriceDistributionToOfferingPartyItemMap[priceDistribution]) ??
    varietyToOfferingPartyItemMap[variety]
  );
}
